<template>

            <label :for="inputId" class="form-label">
              {{ labelText }}
            </label>
            <input
              :type="type"
              class="form-control"
              :id="inputId"
              v-model="inputField"
              :pattern="pattern"
              :maxlength="maxlength"
              :placeholder="intl[$store.state.lang][inputId + '-placeholder'] || null"
              required
            />
            
            <div class="invalid-feedback">
              {{ intl[$store.state.lang][errorLabelKey] }}
            </div>
     
</template>

<script>
import intl from "./intl/intl";

export default {
  name: "textInput",
  components: {
   
   
  },

  props: {
      
      inputId: {
        type: String,
        default: null
      },
      pattern: {
        type: String,
        default: null
      },
      errorLabelKey: {
        type: String,
        default: null
      },
      labelKey: {
        type: String,
        default: null
      },
      required: {
        type: Boolean,
        default: false
      },
      type: {
        type: String,
        default: "text"
      },
      
      maxlength: {
        type: String,
        default: null
      }
     
        
  },
  mounted() {
   
  },
  beforeUnmount() {
    
  },
  data: function () {
    return {
      intl: intl,
      inputField: ""
    };
  },
  methods: {
     
     requiredInputIsOk(){
       if(this.required && this.inputField !== ""){
         if(this.pattern){
           //const regex = new RegExp(this.pattern, 'i');
           return document.getElementById(this.inputId).checkValidity();
         }else{
           return true
         }

       }
       return false
     }
  
         
               
    
  
    
  },
  watch: {
   

  },
  computed: {
    labelText: function () {
      if(this.required){
        return this.intl[this.$store.state.lang][this.labelKey] + '*:'
      }else{
        return this.intl[this.$store.state.lang][this.labelKey] + ':'
      }
       
    },
  },
  
};
</script>
